/* eslint-disable comma-dangle */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
  Button,
  Chip,
  TextField,
  Select,
  MenuItem,
  Paper,
  Typography,
  Tooltip,
  Checkbox,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Grid,
  Card,
  CardContent,
  InputLabel,
  Autocomplete,
  Backdrop,
} from "@mui/material";
import {
  
  Publish,
  AttachFile
} from '@mui/icons-material';
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import {formatDate, formatDateTime, getUniqueStringList} from "../../utils/Formatter";
import { GetActiveMaterialData,GetBeverageProduct,GetPackSizes,GetPackTypes,GetActiveMaterialList} from "../../utils/GetAdmin";
import {uploadImageToVsRepo} from "../../utils/PostAdmin"

interface filterRowMaterial {
  searchMaterial: any;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      margin: '0',
      position: 'absolute',
      top: '50%',
      left: '50%'
    },
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    root: {
      margin: '0',
      padding:'0'

    },
    card: {
    },
    divWidth: {
      width: "100%"
    },
    TextdivWidth: {
      width: "217px"
    },
    gridSpaceable: {
      padding: theme.spacing(2)
    },
    gridMarginTop: {
      marginTop: theme.spacing(2)
    },
    paragraph: {
      padding: theme.spacing(1)
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2)
    },
    checkbox: {
      padding: 0,
      "&$disabled": {
        color: theme.palette.primary.main
      }
    },
    navtab: {
      backgroundColor: theme.palette.grey[100],
    },
    navtabsel: {
      backgroundColor: theme.palette.grey[400],
    },
    primary: {
      marginTop: theme.spacing(2)
    },
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 150
    },
    
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
  }));

  function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
        width: '80%',
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
  }

function LoadingSpinner(){
  return (<CircularProgress />)
}


export default function UploadMaterialImage() {
  const classes = useStyles();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');
  const [codes, setCodes] = React.useState<any>();
  const [materialList,setMaterialList] = useState<any[]>([]);
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:150;
  const controlAdj = 55;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj - controlAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  const [selectedFile, setSelectedFile] = React.useState<File>();
  const [fileName, setfileName] = React.useState<string>();
  const [data, setData] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [rowMaterialNumber, setrowMaterialNumber] = useState<filterRowMaterial>({
    searchMaterial: null,
   });
   const [rowBeverageProduct, setRowBeverageProduct] = React.useState<any>();
  const [rowPackSize, setRowPackSize] = React.useState<any>();
  const [rowPackType, setRowPackType] = React.useState<any>();
  const [rowMaterialName, setRowMaterialName] = React.useState<any>();

  useEffect(() => {
    if (doneLoading) return;
    GetActiveMaterialList(salesOrg).then((v) => {

      setDoneLoading(true);
      if(v) setMaterialList(v);
    })
    setDoneLoading(false);
  }, [doneLoading,salesOrg]);
  
  function getMaterialMetaData(material: any){
  setRowMaterialName(material.material_num);
  GetBeverageProduct(salesOrg,material.material_num).then((v) => {
    setDoneLoading(true);
    if(v )
    setRowBeverageProduct(
      v.mdEquipmentModelMap[0].code
     );
  })
   GetPackSizes(salesOrg,material.material_num).then((v) => {
    setRowPackSize(v.mdEquipmentModelMap[0].code);
  })
  GetPackTypes(salesOrg,material.material_num).then((v) => {
    setRowPackType(v.mdEquipmentModelMap[0].code);

  })
  }
  return (

        <div className={classes.root}>
           {doneLoading ? (
            <div>
            <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
                    <CircularProgress color="primary" />
            </Backdrop>
            <Typography variant="h4"  align="center" className={classes.paragraph}>
                Upload Material Images
            </Typography>
            <Typography
                    variant="subtitle1"
                    className={classes.paragraphAct}
                    paragraph
                  >
                    This section would be used to upload images for selected materials.The uploaded images
                    would then be processed, to remove background,format size,change format to webp,and would be stored in Image repository.
            </Typography>
              <Grid container spacing={2} className={classes.primary}>
                <Grid item xs={12} md={6} style={{ marginLeft: "10px"}}>
                            <InputLabel >Material Number</InputLabel>
                              <Autocomplete
                                        options={materialList}
                                        className={classes.modalInput}
                                        style={{ width: "320px" }}
                                        
                                        getOptionLabel={(option: any) => `${parseInt(option.material_num_short)}-${option.description}`}
                                        onChange={(_, newMat) => {
                                          setrowMaterialNumber({ ...rowMaterialNumber, searchMaterial: newMat });
                                          getMaterialMetaData(newMat);
                                        }}
                                        onKeyDown={(event) => {
                                          if (event.key === "Enter" && (event.target as any).value) {
                                            const newMat = (event.target as any).value;
                                            setrowMaterialNumber({ ...rowMaterialNumber, searchMaterial: newMat });
                                            getMaterialMetaData(newMat);
                                          }
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Search Material"
                                            helperText="Select material to be added"
                                            variant="standard"
                                          />
                                        )}
                                      />
                                      
                </Grid>
              </Grid>
                <Grid container spacing={2} className={classes.primary} style={{ marginBottom: "10px"}}>
                      <Grid item xs={12} md={6}>
                        <Card className={classes.card}>
                          <CardContent>
                          <Typography variant="h5" className={classes.paragraph}>
                            File Name
                          </Typography>
                            
                            <br/>
                            <div className={classes.divWidth}>
                                <Button
                                  color="primary"
                                  component="label"
                                  variant="contained"
                                  style={{marginRight:10}}
                                  className={classes.paragraphButton}>
                                    <AttachFile style={{marginRight:3}} /> 
                                    <input type="file" name="banks" id='bank-file' hidden
                                      onChange={(e) => {
                                        setSelectedFile(undefined)
                                        if(e.target.files){
                                          const extension = e.target.files[0].name.split(".").pop();
                                          setSelectedFile(e.target.files[0]);
                            setfileName(rowMaterialName + '-'+'BPP'+rowBeverageProduct+rowPackType+rowPackSize+'.'+extension);
                            e.target.value = "";
                                        } 
                                      }
                                    }/>
                                </Button>
                                <TextField placeholder='File Name(Format):MatID-BPP.webp' type='text'  value={fileName}  className={classes.TextdivWidth} />
                                
                                <Button
                                    color="primary"
                                    variant="contained"
                                    className={classes.paragraphButton}
                                   disabled={(selectedFile && rowMaterialNumber.searchMaterial)?false:true}  
                                   style={{ marginLeft: "100px"}}  
                                    onClick={(event) => {
                                        if(selectedFile){
                                          setBackdropLoader(true)
                                          uploadImageToVsRepo(salesOrg,selectedFile,fileName).then((result) => {
                                            setBackdropLoader(false)
                                            if(result && result?.data?.status){
                                             setData(result?.data?.message);
            
                                            }                                
                                          })
                                        }
                                      }
                                    }      
                                  >
                                    <Publish/> Upload
                                </Button>
                              </div>
                      
                            
                            </CardContent>
                          </Card>
                      </Grid>
                       {data.length>0 ? (
                        <Grid item xs={12} md={12} xl={12}>
                            <Card className={classes.card}>
                              <CardContent>
                                <Alert severity="info">
                                  <AlertTitle>Info</AlertTitle>
                                  {data}
                                </Alert>
                              </CardContent>
                            </Card>
                        </Grid>
                        ) :  (
                             <div></div>
                        )}
                </Grid>
                </div>
           ):(
            <div className={classes.centerDiv}>
                      <CircularProgress color="primary" />
                    </div>
           )}
        </div>
   )
}
